export default __webpack_public_path__ + "static/media/compass-1.d0b41ddc.png";